import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useApolloClient } from '@vue/apollo-composable'
import { gql } from 'graphql-tag'

export const useLocaleStore = defineStore('locale', () => {

    const { client } = useApolloClient()

    const locales           = ref(null)
    const selectedLanguage  = ref(null)

    const graphqlSettings = ref(null)

    const loadLocales = async () => {

        const { data } = await client.query({
            query: gql`
                query fetchLocalesAndSettings {
                    localeAll(orderBy: { column: "fallback_order", order: ASC }){
                        id
                        code
                        name
                        primary_language
                        fallback_order
                    }
                    settings {
                        pcs_brackets
                    }
                }
            `,

            fetchPolicy: 'network-only'
        })

        locales.value = data?.localeAll ?? null
        graphqlSettings.value = data?.settings ?? null
    }

    const getPrimaryLocale = () => {
        if(!locales.value) return null

        for(const locale of locales.value){
            if(locale.primary_language === true) return locale
        }

        return null
    }

    const getSelectedLanguage = () => {

        if(selectedLanguage.value){
            return selectedLanguage.value
        }

        return getPrimaryLocale()?.code
    }

    const setSelectedLanguage = (code) => {

        let isValid       = false

        for(const locale of locales.value){
            if(locale.code === code){
                isValid = true

                break
            }
        }

        if(!isValid){
            alert(`Can't set "${code}" as selected language. Language not found`)
            return
        }

        selectedLanguage.value = code
    }

    return {
        locales,
        graphqlSettings,
        loadLocales,

        getPrimaryLocale,

        getSelectedLanguage,
        setSelectedLanguage
    }
})